import { DatePicker } from 'antd';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import type { Moment } from 'moment';

// Generate a DatePicker component that uses Moment.js
const MomentDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

export default MomentDatePicker;
